import { connect } from 'react-redux'
import PageWrapper from 'components/layout/Page'
import {
  toggleFullscreenOverlay,
  setPageLeft,
  pageRenderLeft,
  setPageView,
  pageToggleSide,
  pageToggleRight,
  pageToggleOverlay
} from 'redux/actions'

const mapStateToProps = state => ({
  toggleFullscreenOverlay: state.layout.toggleFullscreenOverlay,
  pageState: state.page,
  controller: state.layout.controller,
  browser: state.layout.browser,
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight,
  deviceType: state.layout.deviceType,
  eventCategory: state.accordion.eventCategory
})

const mapDispatchToProps = dispatch => ({
  toggleFullscreenOverlay: fullscreenOverlay => dispatch(toggleFullscreenOverlay(fullscreenOverlay)),
  setPageLeft: left => dispatch(setPageLeft(left)),
  setPageView: pageView => dispatch(setPageView(pageView)),
  pageToggleSide: (side, force) => dispatch(pageToggleSide(side, force)),
  pageToggleRight: force => dispatch(pageToggleRight(force)),
  pageToggleOverlay: overlay => dispatch(pageToggleOverlay(overlay)),
  pageRenderLeft: component => dispatch(pageRenderLeft(component))
})

export default connect(mapStateToProps, mapDispatchToProps)(PageWrapper)
